import React from "react";
import cx from "classnames";
import { Link } from "@/components/Link";

import * as styles from "./Row.module.scss";

type RowProps = {
  className?: string;
  to: string;
  icon: React.ReactNode;
  header: React.ReactNode;
  subHeader: React.ReactNode;
  clamp: React.ReactNode;
  isComplete?: boolean;
  iconClassName?: string;
};

const Row = ({
  to,
  icon,
  header,
  subHeader,
  clamp,
  className,
  isComplete = false,
  iconClassName,
}: RowProps) => {
  return (
    <Link
      className={cx(styles.row, className, {
        [styles.complete]: isComplete,
      })}
      to={to}
    >
      <div className={cx(styles.icon, iconClassName)}>{icon}</div>
      <div className={styles.title}>
        <div className={styles.header}>{header}</div>
        <div className={styles.subHeader}>{subHeader}</div>
      </div>
      <div className={styles.clamp}>{clamp}</div>
    </Link>
  );
};

export { Row };
